export default __webpack_public_path__ + "static/media/barcode_example.0ade3398.png";